import { Component, computed, inject } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

import { AiDockService } from '@services';

import { AI_MODE_KEY, AiPanel, computeDockLayout } from './ai-dock.layout';
import { AiPanelComponent } from './ai-panel.component';

@Component({
  selector: 'app-ai-dock',
  imports: [NgbDropdownModule, TranslatePipe, AiPanelComponent],
  template: `
    @if (dock.visiblePanels().length) {
      <div
        class="ai-dock position-fixed bottom-0 d-flex align-items-end pe-none"
      >
        @if (layout().overflow.length) {
          <div
            ngbDropdown
            class="order-0 align-self-end mb-2 pe-auto"
            placement="top-start"
          >
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              ngbDropdownToggle
            >
              <i class="bi bi-chevron-up me-1"></i>
              {{
                'WEB_AI_MORE_PANELS'
                  | translate: { count: layout().overflow.length }
              }}
            </button>
            <div ngbDropdownMenu role="menu">
              @for (panel of layout().overflow; track panel.id) {
                <button
                  type="button"
                  role="menuitem"
                  ngbDropdownItem
                  (click)="dock.restore(panel.id)"
                >
                  {{ panel.title }} · {{ modeKey[panel.mode] | translate }}
                </button>
              }
            </div>
          </div>
        }

        @for (panel of dock.visiblePanels(); track panel.id) {
          @defer (on immediate) {
            <app-ai-panel
              [panel]="panel"
              [collapsed]="!isExpanded(panel)"
              [style.order]="orderOf(panel)"
              [class.d-none]="isHidden(panel)"
            />
          }
        }
      </div>
    }
  `,
  styles: `
    .ai-dock {
      right: 1rem;
      z-index: 1060;
      gap: 0.75rem;
    }
  `,
})
export class AiDockComponent {
  dock = inject(AiDockService);

  modeKey = AI_MODE_KEY;

  layout = computed(() =>
    computeDockLayout(this.dock.visiblePanels(), this.dock.viewportWidth())
  );

  isExpanded = (panel: AiPanel): boolean =>
    this.layout().expanded.some((item) => item.id === panel.id);

  isHidden = (panel: AiPanel): boolean =>
    this.layout().overflow.some((item) => item.id === panel.id);

  orderOf = (panel: AiPanel): number => {
    const bar = this.layout().bars.findIndex((item) => item.id === panel.id);

    if (bar >= 0) {
      return 10 + (this.layout().bars.length - bar);
    }

    const expanded = this.layout().expanded.findIndex(
      (item) => item.id === panel.id
    );

    return 100 + (this.layout().expanded.length - expanded);
  };
}
